import { Route, Switch } from 'react-router-dom';
import { AssetLabFullscreenPreview } from './AssetLabFullscreenPreview';
import { LinkedCreativePreview } from './LinkedCreativePreview';
import { routes } from '../../router/model';
import React from 'react';
import { SinglePreview } from './SinglePreview';

export const RoutedFullscreenPreview: React.FC<{ parentPath: string }> = ({ parentPath }) => {
  return (
    <Switch>
      <Route path={parentPath + routes.previewCreative}>
        <LinkedCreativePreview back={parentPath} />
      </Route>
      <Route path={parentPath + routes.previewSingle}>
        <SinglePreview back={parentPath} />
      </Route>
      <Route path={parentPath + routes.preview}>
        <AssetLabFullscreenPreview back={parentPath} />
      </Route>
    </Switch>
  );
};
